import { stringifyGraph } from '@/clients/http'
import { ProfileModel } from '@/http/models/Profile'
import { useQuery } from '@tanstack/react-query'

export const useFetchProfile = () => {
  return useQuery({
    queryKey: ['profile'],
    queryFn: async () => {
      const response = await ProfileModel.get({
        query: {
          graph_enc: stringifyGraph({
            '*': true,
            roles: {
              '*': true,
            },
            image: {
              path: true,
              versions: true,
            },
          }),
        },
      })
      if (!response.success) {
        throw new Error(response.error?.data?.message || 'Failed to fetch profile')
      }
      return response.data?.result
    },
  })
}
